module.exports = __webpack_public_path__ + "img/ic_filter_secondary.e83fb371.svg";